import { render, staticRenderFns } from "./vw_student_overall_count.vue?vue&type=template&id=2f8ad581&scoped=true&"
import script from "./vw_student_overall_count.vue?vue&type=script&lang=js&"
export * from "./vw_student_overall_count.vue?vue&type=script&lang=js&"
import style0 from "./vw_student_overall_count.vue?vue&type=style&index=0&id=2f8ad581&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8ad581",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
